<template>
  <v-app v-if="user" v-scroll="onScroll">
    <SideMenu
      :showDrawer="showDrawer"
      @stateChanged="showDrawer = $event"
      @logout="$emit('logout')"
    ></SideMenu>

    <v-app-bar :color="$vuetify.theme.dark ? 'secondary' : 'accent'" dark app>
      <v-app-bar-nav-icon
        @click.stop="showDrawer = !showDrawer"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <LangMenu :showSetDefaultLang="true"></LangMenu>
      <ThemeSwitch
        :dark.sync="darkMode"
        @update:dark="onUpdateDark"
      ></ThemeSwitch>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <slot />
      </v-container>
      <v-fab-transition>
        <v-btn
          fab
          fixed
          bottom
          right
          elevation="3"
          z-index="999"
          color="primary"
          small
          class="scrollToTop"
          @click="scrollToTop"
          v-if="showScrollToTop"
        >
          <v-icon>mdi-format-vertical-align-top</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { UserWithRightOutDTO } from "@/api/models/user/user-with-right.out";
import LangMenu from "@/components/LangMenu.vue";
import ThemeSwitch from "@/components/ThemeSwitch.vue";
import SideMenu from "@/components/SideMenu.vue";
import { StoreGetter } from "@/store/storeGetter.decorator";
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {
    SideMenu,
    LangMenu,
    ThemeSwitch,
  },
})
export default class DefaultLayout extends Vue {
  @StoreGetter("user/user") user!: UserWithRightOutDTO;
  @StoreGetter("user/darkMode") storedDarkMode!: boolean;

  public showDrawer = true;
  public darkMode = false;
  public showScrollToTop = false;

  mounted() {
    this.darkMode = this.storedDarkMode;
  }

  public onUpdateDark(value: boolean) {
    this.$store.commit("user/setDarkMode", value);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onScroll(e: any) {
    if (e && e.srcElement?.scrollingElement?.scrollTop) {
      const topScroll = e.srcElement.scrollingElement.scrollTop;
      this.showScrollToTop = topScroll > 10;
    }
  }

  public scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 599.98px) {
  .scrollToTop {
    display: none;
  }
}

.scrollToTop {
  transform: translateX(85%);

  &:hover {
    transform: translateX(40%);
  }
}
</style>
